import jsGlobals from "./library-js/globals"
import {Objects} from "./library-js/utils";

export default Objects.deepMerge({

}, jsGlobals);

